export const SN_TAX = 'tax'
export const TAX_UPDATE_RULES = SN_TAX + '/UPDATE_RULES'
export const TAX_SET_CALCULATING = SN_TAX + '/SET_CALCULATING'
export const TAX_CLEAR_CALCULATING = SN_TAX + '/CLEAR_CALCULATING'
